<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <w-card :title="label">
      <w-list :items="items" nav color="primary" v-if="items.length > 0">
        <template #item="{ item }">
          <span>{{ item.label }}</span>
        </template>
      </w-list>
    </w-card>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  props: {
    route: [Array, Object, String],
  },
  data() {
    return {
    	items: [],
      label : ''
    }
  },
  methods: {
   
    getData(){
      var menus = this.$page.props.menus
      for (var m in menus) {
            if(menus[m].route == this.route){
              this.label = menus[m].label
              for (var c in menus[m].child) {
                
                if(menus[m].child[c].label){
                 
                this.items.push({ label: menus[m].child[c].label, id: c,  route:  menus[m].child[c].route })
              }
              }
            }
        }
    }
  },
  watch: {

  },
  mounted() {
    this.getData()
    
  },
}
</script>
<style >
ul.info-list {
  list-style-type: none;
}
ul.info-list li b {
  position: relative;
  display: inline-block;
  min-width: 160px;
  margin-right: 8px;
}
ul.info-list li b:after {
  content: ":";
  position: absolute;
  right: 0;
}

</style>
